// Stub Chat data
export const chatData = [
  {
    id: 1,
    name: "System",
    message: "Welcome to ProcureX BIM",
    date: new Date().toISOString(),
    unread: false,
  },
];

export default chatData;
